import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  Icon,
  List,
  ListItem,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useStores } from "../store/store_context";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

const ModalSelectYears = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.updateSelectedYears([]);
  }, []);

  const allYears = (pageStore.all_years || []).filter((year) => year !== "None").sort((a, b) => Number(a) - Number(b));;

  const handleSelectYear = (year) => {
    const updated = pageStore.selected_years.includes(year)
      ? pageStore.selected_years.filter((y) => y !== year)
      : [...pageStore.selected_years, year];

    pageStore.updateSelectedYears(updated);
  };

  const handleSelectAllYears = () => {
    const updated =
      pageStore.selected_years.length === allYears.length ? [] : [...allYears];

    pageStore.updateSelectedYears(updated);
  };

  const handleReset = () => {
    pageStore.updateSelectedYears([]);
  };

  return (
    <Box position="relative" width="150px">
      <Box >
        <List spacing={1}>
          {allYears.map((year, index) => (
            <ListItem
              key={index}
              borderRadius="md"
              _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
            >
              <Checkbox
                isChecked={pageStore.selected_years.includes(year)}
                onChange={() => handleSelectYear(year)}
                colorScheme="blue"
                color="myColor.white"
              >
                {year}
              </Checkbox>
            </ListItem>
          ))}
          <ListItem
            borderRadius="md"
            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
          >
            <Checkbox
              isChecked={
                pageStore.selected_years.length > 0 &&
                allYears.every((year) => pageStore.selected_years.includes(year))
              }
              isIndeterminate={
                pageStore.selected_years.length > 0 &&
                !allYears.every((year) => pageStore.selected_years.includes(year))
              }
              onChange={handleSelectAllYears}
              colorScheme="blue"
              color="myColor.white"
            >
              <Text as="span" fontWeight="bold">
                Выбрать все
              </Text>
            </Checkbox>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
});

export default ModalSelectYears;
